export const tableFilterChanged = (filter, model) => dispatch => {
  dispatch({
    type: 'FILTER_CHANGED',
    filter,
    model,
  });
};
